import update from './update'

export default {
  namespaced: true,
  modules: {
    update
  }
}
